module.exports = class PaginationRenderer {
  constructor() {}

  clearCardShells() {
    const container = document.querySelector('#pull-results');

    const cardShells = container.querySelectorAll('.cui-shell-card');

    if (cardShells && cardShells.length) {
      cardShells.forEach(cardShellElement =>
        cardShellElement.parentElement.removeChild(cardShellElement)
      );
    }
  }

  clearPaginatedCards() {
    const container = document.querySelector('#pull-results');

    container.innerHTML = '';
  }

  insertPaginatedCards(response) {
    const { cardsHtml } = response;

    const browseContainer = document.querySelector('#pull-results');

    if (browseContainer) {
      browseContainer.innerHTML = cardsHtml;
    }

    if (window.CardUI) {
      window.CardUI.init();
    }
  }

  insertLazyLoadedCards(response) {
    const { cardsHtml } = response;

    const browseContainer = document.querySelector('#pull-results');

    if (browseContainer) {
      browseContainer.insertAdjacentHTML('beforeend', cardsHtml);
    }

    if (window.CardUI) {
      window.CardUI.init();
    }
  }

  insertBottomContent(bottomContentHtml) {
    if (!bottomContentHtml) {
      return;
    }

    const bottomContentContainer = document.querySelector(
      '#pull-bottom-content'
    );

    if (bottomContentContainer) {
      bottomContentContainer.insertAdjacentHTML('beforeend', bottomContentHtml);
    }

    if (window.CardUI) {
      window.CardUI.init();
    }
  }

  restoreCardsHtmlFromState(cardsHtml) {
    if (!cardsHtml || !cardsHtml.length) {
      return;
    }

    const browseContainer = document.querySelector('#pull-results');

    if (browseContainer) {
      browseContainer.innerHTML = cardsHtml;
    }

    if (window.CardUI) {
      window.CardUI.init();
    }
  }

  restoreBottomContentHtmlFromState(cardsHtml) {
    if (!cardsHtml || !cardsHtml.length) {
      return;
    }

    const bottomContentContainer = document.querySelector(
      '#pull-bottom-content'
    );

    if (bottomContentContainer) {
      bottomContentContainer.outerHTML = cardsHtml;
    }

    if (window.CardUI) {
      window.CardUI.init();
    }
  }

  scrollToTop() {
    const headerPositionElement = document.querySelector('.header-position');
    if (headerPositionElement) {
      headerPositionElement.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    } else if (window.scrollTo) {
      window.scrollTo(0, 0);
    }
  }

  attachPaginationClickHandler(eventHandler) {
    const paginationElements = document.querySelectorAll('.pagination a');

    if (paginationElements && paginationElements.length) {
      paginationElements.forEach(element => {
        element.addEventListener('click', eventHandler);
      });
    }
  }
};
